import { filterDiffFunction, getMenuTypeDiffPath } from './chunk-WTGT4IDV.mjs';
import { currentPrepStationsSelector, currentKitchenTicketSettingsSelector, selectCurrentSettingsData, settingsDifferencesSelector } from './chunk-67X7HZEW.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import deepDiff from 'deep-diff';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import has from 'lodash/has';
import orderBy from 'lodash/orderBy';
import setWith from 'lodash/setWith';

var SORT_PRIORITY_FIELD = "order";
var TicketDisplayFieldLabels = /* @__PURE__ */ ((TicketDisplayFieldLabels2) => {
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["printUnfiredItems"] = 0] = "printUnfiredItems";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["printModifications"] = 1] = "printModifications";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showCourses"] = 2] = "showCourses";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showOrderTags"] = 3] = "showOrderTags";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showSeatTags"] = 4] = "showSeatTags";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["headerBlankSpace"] = 5] = "headerBlankSpace";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["elementSpacing"] = 6] = "elementSpacing";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["orderTagColors"] = 7] = "orderTagColors";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["displayDefaultModifiers"] = 8] = "displayDefaultModifiers";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["consolidateByItem"] = 9] = "consolidateByItem";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["hideModGroupTitles"] = 10] = "hideModGroupTitles";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["groupSameModItems"] = 11] = "groupSameModItems";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["addSubForMultiSelectOff"] = 12] = "addSubForMultiSelectOff";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["noForDeselectedDefaultModifiers"] = 13] = "noForDeselectedDefaultModifiers";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["modifierItemDisplayMode"] = 14] = "modifierItemDisplayMode";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["colorOfModifierItems"] = 15] = "colorOfModifierItems";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["orderTagsFontSize"] = 16] = "orderTagsFontSize";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["groupBySeat"] = 17] = "groupBySeat";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["updateOrderVoidText"] = 18] = "updateOrderVoidText";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["updateOrderNewText"] = 19] = "updateOrderNewText";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["updateOrderTextPosition"] = 20] = "updateOrderTextPosition";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["updateOrderTextColor"] = 21] = "updateOrderTextColor";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showCourseName"] = 22] = "showCourseName";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["changeNoSeatTextInToGoOrders"] = 23] = "changeNoSeatTextInToGoOrders";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["printOrderQr"] = 24] = "printOrderQr";
  return TicketDisplayFieldLabels2;
})(TicketDisplayFieldLabels || {});
var CustomizingReceiptsFieldLabels = /* @__PURE__ */ ((CustomizingReceiptsFieldLabels2) => {
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["append"] = 0] = "append";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["color"] = 1] = "color";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["fontSize"] = 2] = "fontSize";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["fontWeight"] = 3] = "fontWeight";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["justify"] = 4] = "justify";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["line"] = 5] = "line";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["order"] = 6] = "order";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["prepend"] = 7] = "prepend";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["status"] = 8] = "status";
  CustomizingReceiptsFieldLabels2[CustomizingReceiptsFieldLabels2["noLineBreak"] = 9] = "noLineBreak";
  return CustomizingReceiptsFieldLabels2;
})(CustomizingReceiptsFieldLabels || {});
var CustomizingReceiptsValueIdFieldLabels = /* @__PURE__ */ ((CustomizingReceiptsValueIdFieldLabels2) => {
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["updateStatus"] = 0] = "updateStatus";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["orderType"] = 1] = "orderType";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["orderName"] = 2] = "orderName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["orderNumber"] = 3] = "orderNumber";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["table"] = 4] = "table";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["placedBy"] = 5] = "placedBy";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["server"] = 6] = "server";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["dateAndTime"] = 7] = "dateAndTime";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["stationName"] = 8] = "stationName";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["address"] = 9] = "address";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["guestCount"] = 10] = "guestCount";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["itemNameAndQuantity"] = 11] = "itemNameAndQuantity";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["seatNumber"] = 12] = "seatNumber";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["seatTags"] = 13] = "seatTags";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["modifiersInfo"] = 14] = "modifiersInfo";
  CustomizingReceiptsValueIdFieldLabels2[CustomizingReceiptsValueIdFieldLabels2["time"] = 15] = "time";
  return CustomizingReceiptsValueIdFieldLabels2;
})(CustomizingReceiptsValueIdFieldLabels || {});
var returnLabel = (field) => {
  if (field in TicketDisplayFieldLabels) {
    return i18n_config_default.t(
      `app.modals.kitchenTicketDiffModal.ticketDisplay.${field}`
    );
  }
  if (field in CustomizingReceiptsFieldLabels) {
    return field;
  }
  if (field in CustomizingReceiptsValueIdFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.kitchenTicketSettings.customizingReceiptsTable.value.options.${field}`
    );
  }
};
var diffKitchenTicketFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    return {
      prepStationVersions: generatePrepStationVersionsDiff(diffArray, state)
    };
  }
  return null;
};
var generatePrepStationVersionsDiff = (diffArray, state) => {
  const prepStationVersions = [];
  const prepStations = currentPrepStationsSelector(state);
  const groupedByPrepStationId = groupBy(diffArray, "path.1");
  Object.entries(groupedByPrepStationId).forEach(([prepStationId, diffs]) => {
    var _a;
    const ticketDisplay = generateTicketDisplayArray(diffs);
    const customizingReceipts = generateCustomizingReceiptsObj(diffs);
    const prepStationNumberId = Number(prepStationId);
    prepStationVersions.push({
      ticketDisplay,
      customizingReceipts,
      id: prepStationNumberId,
      label: (_a = prepStations[prepStationNumberId]) == null ? void 0 : _a.name,
      totalOfChanges: diffs.length,
      action: "update"
    });
  });
  return prepStationVersions;
};
var generateTicketDisplayArray = (diffArray) => {
  const ticketDisplay = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength < 3) {
          return;
        }
        if (!(field in TicketDisplayFieldLabels)) {
          return;
        }
        if ([
          "orderTagColors",
          "colorOfModifierItems",
          "updateOrderTextColor"
        ].includes(field)) {
          ticketDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `settingsModule.kitchenTicketSettings.printerColors.${newDiff.value}`
            )
          }));
        } else if (field === "modifierItemDisplayMode") {
          ticketDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `settingsModule.registerTicketSettings.ticketDisplay.modifiersDisplay.modifierItemDisplayMode.options.${newDiff.value}`
            )
          }));
        } else if (field === "orderTagsFontSize") {
          ticketDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.${newDiff.value}`
            )
          }));
        } else if (field === "headerBlankSpace" || field === "elementSpacing") {
          ticketDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: `${newDiff.value}"`
          }));
        } else if (field === "updateOrderTextPosition") {
          ticketDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `commonTexts.${newDiff.value.toString().toLowerCase()}`
            )
          }));
        } else {
          ticketDisplay.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return ticketDisplay;
};
var generateCustomizingReceiptsObj = (diffArray) => {
  const ticketHeader = [];
  const ticketFooter = [];
  const ticketBody = [];
  const TICKET_HEADER_FIELD = "ticketHeader";
  const TICKET_BODY_FIELD = "ticketBody";
  const TICKET_FOOTER_FIELD = "ticketFooter";
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength }) => {
        if (diffLength !== 5) {
          return;
        }
        const tableField = diff.path[2];
        const id = diff.path[3];
        if (diff.kind === "E") {
          const customNewDiff = {
            field,
            label: returnLabel(field) || "",
            value: diff.rhs
          };
          if (tableField === TICKET_HEADER_FIELD) {
            if (!ticketHeader.find((row) => row.id === id)) {
              ticketHeader.push({
                id,
                label: returnLabel(id) || "",
                changes: [customNewDiff]
              });
            } else {
              for (const [i, row] of ticketHeader.entries()) {
                if (row.id === id) {
                  ticketHeader[i].changes = [...row.changes, customNewDiff];
                  break;
                }
              }
            }
          } else if (tableField === TICKET_BODY_FIELD) {
            if (!ticketBody.find((row) => row.id === id)) {
              ticketBody.push({
                id,
                label: returnLabel(id) || "",
                changes: [customNewDiff]
              });
            } else {
              for (const [i, row] of ticketBody.entries()) {
                if (row.id === id) {
                  ticketBody[i].changes = [...row.changes, customNewDiff];
                  break;
                }
              }
            }
          } else if (tableField === TICKET_FOOTER_FIELD) {
            if (!ticketFooter.find((row) => row.id === id)) {
              ticketFooter.push({
                id,
                label: returnLabel(id) || "",
                changes: [customNewDiff]
              });
            } else {
              for (const [i, row] of ticketFooter.entries()) {
                if (row.id === id) {
                  ticketFooter[i].changes = [...row.changes, customNewDiff];
                  break;
                }
              }
            }
          }
        }
      },
      returnLabel
    )
  );
  return {
    ticketHeader,
    ticketBody,
    ticketFooter
  };
};
var applyKitchenTicketChangesToPrepStations = (formattedPrepStationVersions, hasPrepStationsToApplyChanges, state) => {
  const originalData = currentKitchenTicketSettingsSelector(state);
  const clonedKitchenTicketData = cloneDeep(
    selectCurrentSettingsData(state)
  );
  const differences = orderBy(settingsDifferencesSelector(state), (change) => {
    const field = change.path[change.path.length - 1];
    return field === SORT_PRIORITY_FIELD ? change.rhs : 0;
  });
  const changedSetFunction = (diff, prepStationIdToApply) => {
    const diffPath = getMenuTypeDiffPath(diff.path, prepStationIdToApply);
    const path = diffPath.join(".");
    if (has(clonedKitchenTicketData, path)) {
      setWith(clonedKitchenTicketData, path, diff.rhs, Object);
    }
  };
  if (hasPrepStationsToApplyChanges) {
    hasPrepStationsToApplyChanges.prepStationsToApplyChanges.forEach(
      (prepStation) => {
        const prepStationIdToApply = prepStation.prepStationId;
        differences.forEach(
          (diff) => changedSetFunction(diff, prepStationIdToApply)
        );
      }
    );
    const newDifferences = deepDiff(
      originalData,
      clonedKitchenTicketData
    );
    const newDiffObject = diffKitchenTicketFactory(newDifferences, state);
    return {
      prepStationVersions: newDiffObject == null ? void 0 : newDiffObject.prepStationVersions,
      changeData: clonedKitchenTicketData
    };
  }
  return {
    prepStationVersions: formattedPrepStationVersions,
    changeData: clonedKitchenTicketData
  };
};

export { applyKitchenTicketChangesToPrepStations, diffKitchenTicketFactory };
